import Paper, { PaperProps } from '@mui/material/Paper';
import Draggable from 'react-draggable';

function DraggablePaper(props: PaperProps) {
  return (
    <Draggable
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper {...props} />
    </Draggable>
  );
}

export default DraggablePaper